module.exports = "/assets/data/aae3f62e2d72261f4724e05f5daa8541-GU11.data.json";